import "./App.css";
import Dashboard from "./Pages/Dashboard";
import { Link, Route, Routes } from "react-router-dom";
import Login from "./components/Login/Login";
import ProtectedRoutes from "./Guards/ProtectedRoutes";
import Gravámenes from "./Pages/Permisos/Gravamenes";
import EstadoTramite from "./Pages/Estado/EstadoTramite";

function App () {
  return (
    <>
      <Routes>
        <Route exact path="/" element={ <Login /> }></Route>
        <Route element={ <ProtectedRoutes /> }>
          <Route path="/dashboard" element={ <Dashboard /> }></Route>
          <Route path="/gravamenes" element={ <Gravámenes /> }></Route>
          {/* <Route path="/consultar" element={ <EstadoTramite /> }></Route> */ }

        </Route>
      </Routes>
    </>
  );
}

export default App;
